export const translations = {
    'Notifications & News': 'Thông Báo & Tin Tức',
    'Get notifications for news or jobs': 'Nhận thông báo tin tức hoặc công việc',
    Notifications: 'Thông Báo',
    'Get notifications for jobs': 'Nhận thông báo công việc',
    All: 'Tất cả',
    Unread: 'Chưa đọc',
    Read: 'Đã đọc',
    'has invited you to apply': 'đã mời bạn ứng tuyển vị trí',
    'viewed your profile.': 'đã xem hồ sơ của bạn.',
    ago: 'trước',
    years: 'năm',
    months: 'tháng',
    weeks: 'tuần',
    days: 'ngày',
    hours: 'giờ',
    minutes: 'phút',
    year: 'năm',
    month: 'tháng',
    week: 'tuần',
    day: 'ngày',
    hour: 'giờ',
    minute: 'phút',
    'Just now': 'Vừa xong',
    Job: 'Việc làm',
    'saved jobs': 'đã lưu',
    'expires in': 'hết hạn trong',
    'Who viewed my profile': 'Nhà tuyển dụng xem hồ sơ',
    'Employer viewed your application': 'Nhà tuyển dụng đã xem đơn ứng tuyển',
    'viewed your application': 'đã xem đơn ứng tuyển',
    'viewed your application for position': 'đã xem đơn ứng tuyển vị trí',
    'Saved jobs': 'Việc làm đã lưu',
    'Viewed resume': 'Đã xem hồ sơ',
    'Apply status': 'Trạng thái ứng tuyển',
    'Job invitation': 'Mời ứng tuyển',
    'Which employers have viewed your profile in the last 7 days?':
        'Nhà tuyển dụng nào đã quan tâm đến bạn trong 7 ngày vừa qua?',
    'And more information, hot jobs waiting for you.': 'Các thông tin, việc làm hấp dẫn đang chờ bạn.',
    'LOGIN NOW!': 'ĐĂNG NHẬP NGAY!',
    'Login now': 'Đăng nhập ngay',
    'Update profile': 'Cập nhật hồ sơ',
    "Your profile hasn't been viewed by any employer for the last 7 days":
        'Hồ sơ của bạn rất ít tương tác trong 7 ngày qua',
    'Update your profile for more opportunities': 'Cập nhật hồ sơ để nâng cao cơ hội tìm việc',
    'There are no unread notifications.': 'Không có thông báo nào chưa đọc.',
    'There are no read notifications.': 'Không có thông báo nào đã đọc.',
    '/my-profile': '/ho-so',
    'Employer declined your application': 'Nhà tuyển dụng từ chối hồ sơ',
    'reviews you unsuitable for the position': 'đánh giá bạn không phù hợp cho vị trí',
    'selected you for position': 'đã chọn bạn cho vị trí',
    'Employer selected your application': 'Hồ sơ của bạn đã được chọn'
} as const
export type TTranslationKey = keyof typeof translations
